import axios from "axios";
import { apiEndpoints, host } from "../../../utils/constants";
import parseJwt from "../../../utils/helper/jwtParser";
import {
  getAccessToken,
  getRefreshToken,
  logout,
  setAccessToken,
} from "./../../accessToken";

const checkIfLoggedInOrNot = async () => {
  const refreshToken = getRefreshToken();
  if (!refreshToken || parseJwt(refreshToken).invalid) {
    logout();
    return false;
  }
  const accessToken = getAccessToken();
  if (accessToken) {
    const parsedJwt = parseJwt(accessToken);
    if (!parsedJwt.invalid && "userId" in parsedJwt) {
      return true;
    }
  }
  return await fetchAuthToken();
};

const fetchAuthToken = async () => {
  try {
    //TODO Handle network failures
    const {
      data: { data },
    } = await axios.get(host + "/auth/refresh", {
      headers: {
        Authorization: `Bearer ${getRefreshToken()}`,
      },
    });
    if (data && data.accessToken) {
      setAccessToken(data.accessToken);
      return true;
    }
    return false;
  } catch {
    logout();
    return false;
  }
};

export const logOut = () => {
  // Fire-and-forget: notify the server before clearing tokens so the
  // Authorization header can still be attached.
  const token = getAccessToken();
  if (token) {
    try {
      fetch(`${host}/auth/logout_session`, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}` },
        keepalive: true,
      }).catch(() => {});
    } catch {}
  }

  logout();
  if (typeof window !== "undefined") {
    try {
      sessionStorage.clear();
    } catch {}
    try {
      localStorage.clear();
    } catch {}
  }
};

export default checkIfLoggedInOrNot;
